<template>
  <div id="app">
    <header>
      <div class="labels-container">
        <p><span>Cliente:</span> Suzuki Motor de México</p>
        <p><span>Proyecto:</span> Website 2019</p>
      </div>
      <div class="logo">
        <a href="https://www.marciano.com.mx">
          <img src="/main-logo-negative.png" alt="Marciano®" />
        </a>
      </div>
    </header>
    <main>
      <div class="phone">
        <iframe
          width="375"
          height="667"
          src="https://xd.adobe.com/embed/be23467c-54b1-4587-7e5d-eb15fa631dd5-c812/?fullscreen"
          frameborder="0"
          allowfullscreen
        ></iframe>
        <div id="chat" class="glow"></div>
      </div>
    </main>
    <footer>
      <p>© Marciano Studio S.C., 2019.</p>
      <div v-show="chatOpen" class="mask" style="z-index:9999999999"></div>
    </footer>
  </div>
</template>
<script>
export default {
  data() {
    return {
      chatOpen: false
    };
  },
  methods: {
    onOpenChat() {
      this.chatOpen = true;
    },
    onCloseChat() {
      setTimeout(() => {
        this.chatOpen = false;
      }, 500);
    }
  },
  mounted() {
    window.BE_API = window.BE_API || {};
    window.BE_API.onChatWindowOpen = this.onOpenChat;
    window.BE_API.onChatWindowClose = this.onCloseChat;
  }
};
</script>

<style lang="scss">
body {
  margin: 0;
  padding: 0;
}
#app {
  font-family: "Bahnschrift semicondensed", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background-color: #0d131f;
  width: 100vw;
  height: 100vh;
  overflow: hidden;

  header {
    display: flex;
    flex-direction: row;
    width: 100%;
    align-items: stretch;
    position: absolute;
    .labels-container {
      padding: 20px;
      display: flex;
      flex-direction: column;
      align-items: stretch;
      justify-content: stretch;
      p {
        flex: 1 1 auto;
        color: #fff;
        font-size: 20px;
        font-weight: 100;
        span {
          font-size: 14px;
          display: block;
          color: #1c65e1;
          font-weight: 100;
        }
      }
    }
    .logo {
      flex: 1 1 auto;
      text-align: right;
      img {
        padding: 30px;
        width: 180px;
      }
    }
  }
  main {
    display: flex;
    align-items: center;
    justify-content: center;
    align-content: center;
    height: 100vh;
    width: 100vw;
    .phone {
      background-image: url("/s10.png");
      background-size: contain;
      background-repeat: no-repeat;
      width: 437px;
      min-width: 437px;
      margin-top: 40px;
      height: 790px;
      text-align: center;
      padding-top: 80px;
      position: relative;
      .glow {
        background-image: url("/glow.png");
        background-size: contain;
        background-repeat: no-repeat;
        width: 460px;
        height: 870px;
        pointer-events: none;
        position: absolute;
        top: 0;
        left: 0;
      }
    }
  }
  footer {
    display: block;
    width: 100vw;
    bottom: 0;
    left: 0;
    position: absolute;
    color: #fff;
    p {
      padding: 20px;
      display: block;
      margin: 0;
    }
    .mask {
      bottom: 0;
      right: 0;
      height: 30px;
      width: 180px;
      position: absolute;
      background-color: #0d131f;
    }
  }
}
</style>
